/* eslint-disable @typescript-eslint/unbound-method */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import { UserDO } from 'wdna-components/lib/types.new';

import { RootState } from '../../../reducers';

interface Props extends RouteComponentProps {
  user: UserDO | undefined;
}

interface State {
  email?: string;
  error?: boolean;
}

class Forgot extends React.PureComponent<Props, State> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      email: '',
      error: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  public handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  }

  public handleFormSubmit(e: React.FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    this.setState({
      error: false,
    });
  }

  public render(): JSX.Element {
    const { user } = this.props;

    if (user) {
      return <Redirect to="/" />;
    }

    return (
      <div id="extr-page">
        <div id="main" role="main" className="animated fadeInDown">
          <div id="content" className="container login-layer">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 login-box">
              <form id="login-form" className="smart-form" onSubmit={this.handleFormSubmit}>
                <header>
                  <div id="login-logo">
                    <img src="assets/img/logos/logo_negativo.png" alt="logo" />
                  </div>
                </header>
                <fieldset>
                  <section>
                    <label className="input">
                      <input
                        type="email"
                        name="email"
                        value={_.defaultTo(this.state.email, '')}
                        placeholder="Email"
                        onChange={this.handleChange}
                      />
                    </label>
                  </section>
                  <section className="check-login">
                    <div className="note">
                      <a href="/#/login">I remembered my password</a>
                    </div>
                  </section>
                </fieldset>
                <footer>
                  {this.state.error ? (
                    <span className="help-block animated shake" style={{ float: 'left', color: '#A90329' }}>
                      <i className="fa fa-warning" /> {this.state.error}
                    </span>
                  ) : null}
                  <button type="submit" className="btn btn-primary">
                    Restore
                  </button>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: Props): Props => {
  return {
    ...ownProps,
    user: _.get(state, ['auth', 'user'], undefined),
  };
};

export default withRouter(connect(mapStateToProps)(Forgot));
